<template>
    <v-select  
       :value="selected_statcodes"      
       v-model="selectedstatcodes"
       v-bind:items="filtered_statcodes"
       item-value="code" 
       item-text="description" 
       :label="label"
       :dense="isDense"
       :clearable="isClearable"
       :multiple="isMultiple"
       @change="updateData()"
       v-on:click:clear="callClear()">
       <template v-slot:prepend-item>
            <v-list-item ripple @mousedown.prevent @click="toggle">
                <v-list-item-action>
                    <v-icon :color="selectedstatcodes.length > 0 ? 'indigo darken-4' : ''"> {{ getIcon() }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>       
        <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index >= 0 && index < visibleChips">
                <span>{{ item.code }}</span>
            </v-chip>
            <span v-if="index === visibleChips" class="grey--text text-caption">(+{{ selectedstatcodes.length - visibleChips }})</span>
        </template>                                                        
     
    </v-select>
</template>

<script>
export default {
    props: {
        selected_statcodes: {
            type: Array,
            default: function() { return []; },
        },
        label: {
            type: String,
            default: 'Status'
        },   
        field: {
            default: 'statcodesSelected',
            required: true,
        },
        isClearable:{
            type: Boolean,
            default: false
        },
        isDense: {
            type: Boolean,
            init: false
        },
        isMultiple:{
            type: Boolean,
            default: true
        },  
        visibleChips:{
            type: Number,
            default: 16
        },
        showInactive: {
            type: Boolean,
            default: true
        },        
        localStorageItem:{
            type: String,
            default: 'search.acco.statcodes'
        },
        initializeEmpty: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        selected_statcodes(newVal) {
            if (newVal && newVal.length > 0 && JSON.stringify(newVal) !== JSON.stringify(this.selectedstatcodes)) {
                this.selectedstatcodes = [...newVal];
                this.updateData();
            }
        }
    },
    computed: {
        filtered_statcodes: function() { // filter on user being active
            return this.statcodes.filter(el => {
                return this.showInactive ? true : el.active;
            });            
        },
    },        
    data() {
        return {
            statcodes: [],
            selectedstatcodes: [],
        }
    },
    created() {
        this.getHustCodes();
    },
    methods: {
        callClear(){
            this.selectedstatcodes = [];
        },
        getIcon: function () {
            if (this.isAllSelected()) return 'mdi-close-box'
            if (this.isSomeSelected()) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },    
        isAllSelected: function () {
            return this.selectedstatcodes.length === this.statcodes.length; 
        },
        isSomeSelected: function () {            
            return this.selectedstatcodes.length > 0 && this.selectedstatcodes.length !== this.statcodes.length;
        },   
        toggle() {
            this.$nextTick(() => {
                if (this.isAllSelected()) {
                    this.selectedstatcodes = [];
                    this.updateData();
                } else {
                    this.selectAll();
                    this.updateData();
                }
            })
        },
        selectAll(){
            this.selectedstatcodes = [];
            this.statcodes.forEach(x => {
                this.selectedstatcodes.push(x.code);
            });
        }, 
        updateData(){              
            this.$emit('updateData', { "field": this.field, "value": this.selectedstatcodes })
        },                         
        getHustCodes() {
            this.$axios
                .post("ares/json/ares/huis/stat/getStat.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getStat"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        //console.log(res);
                        this.statcodes = res.data.getStat;
                        if(!this.initializeEmpty && localStorage.getItem(this.localStorageItem)!==null){
                           this.selectedstatcodes=localStorage.getItem(this.localStorageItem).split(",");
                        } else if(!this.initializeEmpty) {
                           this.selectAll();
                        }
                        this.updateData();
                    }
                })
        },
    }
}
</script>

<style scoped>

</style>